export default {"src":"/_next/static/media/calendar-icon.a0c1c9de.svg","height":58,"width":54};